import { DeviceType } from '@/types/device-info';

export const deviceMenuOptions = [
    {
        name: 'AirBolt Portable Smart Lock',
        value: DeviceType.AirboltTravelLock,
    },
    {
        name: 'AirBolt GPS',
        value: DeviceType.AirboltGps,
    },
    {
        name: 'AirBolt Card',
        value: DeviceType.AirboltCard,
    },
    {
        name: 'All Devices',
        value: 'all',
    },
];
